/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFormByFormID } from "./fetchData";
import { ProgressSpinner } from "primereact/progressspinner";

const ViewEquipmentform = ({ attachedFormData }: any) => {
  const query = new URLSearchParams(window.location.search);
  const formIDParam = Number(query.get("formID"));

  const toast = useRef<Toast>(null);
  const [formData, setFormData] = useState<any>(attachedFormData ?? null);
  const [formDataLoading, setFormDataLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!attachedFormData) {
      if (!formIDParam) {
        navigate("/layout/health-and-safety/pre-use-equipment-checklist");
      }
      getFormByFormID(
        setFormData,
        setFormDataLoading,
        formIDParam,
        navigate,
        toast
      );
    }
  }, []);

  // Format date and time from timestamp
  const formatDateTime = (timestamp: number) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  return (
    <>
      {formDataLoading ? (
        <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[50px] lg:tw-left-[120px] tw-z-50">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="form-border">
          {!attachedFormData && (
            <div className="form-header-border">
              <h2 className="form-header-h2">
                View Pre-Use Equipment Checklist
              </h2>
            </div>
          )}
          <>
            <div>
              <div className="tw-grid tw-grid-cols-1  2xl:tw-grid-cols-3 tw-gap-6 tw-px-4 tw-py-4">
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
                  <p className="leak-detail-label">Site</p>
                  <p className="leak-value">
                    {formData?.formJson?.site || "N/A"}
                  </p>
                </div>
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
                  <p className="leak-detail-label">Completed By</p>
                  <p className="leak-value">
                    {formData?.formJson?.completedBy?.displayName || "N/A"}
                  </p>
                </div>
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
                  <p className="leak-detail-label">Date & Time</p>
                  <p className="leak-value">
                    {formatDateTime(formData?.formJson?.dateTime) || "N/A"}
                  </p>
                </div>
              </div>
              <div className="tw-mt-6">
                <DataTable
                  value={formData?.formJson?.loweringEquipment || []}
                  className="p-datatable-striped"
                  showGridlines
                >
                  <Column field="label" header="Lowering Equipment" />
                  <Column
                    header="Action"
                    body={(rowData) =>
                      rowData.value === "yes" ? (
                        <span>Yes</span>
                      ) : rowData.value === "no" ? (
                        <span>No</span>
                      ) : (
                        <span>N/A</span>
                      )
                    }
                  />
                </DataTable>
                <DataTable
                  value={formData?.formJson?.surveyEquipment || []}
                  className="p-datatable-striped tw-mt-6"
                  showGridlines
                >
                  <Column field="label" header="Survey Equipment" />
                  <Column
                    header="Action"
                    body={(rowData) =>
                      rowData.value === "yes" ? (
                        <span>Yes</span>
                      ) : rowData.value === "no" ? (
                        <span>No</span>
                      ) : (
                        <span>N/A</span>
                      )
                    }
                  />
                </DataTable>
              </div>
              {!attachedFormData && (
                <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
                  <Button
                    className="form-cancel-button"
                    label="Back"
                    onClick={() =>
                      navigate(
                        "/layout/health-and-safety/pre-use-equipment-checklist"
                      )
                    }
                    color="white"
                  />
                </div>
              )}
            </div>
          </>
        </div>
      )}
    </>
  );
};

export default ViewEquipmentform;
